import { useEffect } from 'react';
import { ArrowDownTrayIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../hooks/useAuth';
import { usePwaInstall } from '../hooks/usePwaInstall';
import { registerPushSelfHealing } from '../lib/push';

export const InstallPrompt = () => {
  const { user } = useAuth();
  const { canInstall, promptInstall, dismissed, dismiss } = usePwaInstall();

  // InstallPrompt mounts on every authenticated screen (AppShell), which makes
  // it the app-open hook for push subscription self-healing: when sw.js could
  // not re-register a rotated subscription itself, redo it here through the
  // normal CSRF-protected API flow. Scoped to the signed-in user so a shared
  // device never re-binds another user's subscription. Returns its own cleanup.
  const userId = user?.id;
  useEffect(() => {
    if (userId === undefined) {
      return;
    }
    return registerPushSelfHealing(userId);
  }, [userId]);

  if (!canInstall || dismissed) {
    return null;
  }

  return (
    <div className="pb-safe fixed inset-x-0 bottom-0 z-50 px-4 pb-[max(1rem,calc(env(safe-area-inset-bottom)+0.5rem))] md:bottom-4 md:left-auto md:right-4 md:w-80 md:px-0">
      <div className="flex items-center gap-3 rounded-2xl border border-line bg-surface-2 p-3 shadow-panel">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-500/10 text-brand-500">
          <ArrowDownTrayIcon className="h-5 w-5" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-[14px] font-semibold">Pridať ONVI WORKS na plochu</p>
          <p className="truncate text-[12px] text-slate-500 dark:text-slate-400">
            Rýchly prístup ako z aplikácie.
          </p>
        </div>
        <button
          type="button"
          onClick={() => void promptInstall()}
          className="shrink-0 rounded-lg bg-brand-500 px-3 py-1.5 text-[13px] font-semibold text-white transition active:scale-95"
        >
          Pridať
        </button>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Zavrieť"
          className="shrink-0 rounded-lg p-1.5 text-slate-400 transition hover:bg-black/[0.04] dark:hover:bg-white/[0.06]"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
